module.exports = __webpack_public_path__ + "static/Orleans-Interior-Design-Painting-1-of-1ed-1024x684-a5eabfb7eac6e912efb7759946214880.jpg";